<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';
  import SelecaoBusca from './SelecaoBusca.vue';
  import RateioProjetos from './RateioProjetos.vue';
  import ComplementoSugerido from './ComplementoSugerido.vue';
  import sugestoesDoHistorico from '../sugestoes-historico';
  import BlocoOperacao from './BlocoOperacao.vue';
  import AnexosOperacao from './AnexosOperacao.vue';
  import anexosMixin, { DESTINO_CONTA_RECEBER } from '../anexos';

  export default {
    components: { SelecaoBusca, DatePicker, RateioProjetos, ComplementoSugerido, BlocoOperacao, AnexosOperacao },
    mixins: [anexosMixin],
    props: {
      idContaCript: { type: String, required: true },
      debito: { type: Object, required: true },
      nomeContaTransitoria: { type: String, default: '' },
    },
    data() {
      return {
        gravando: false,
        carregando: true,
        validar: false,
        baixarAgora: null,
        origem: null,
        comTaxa: false,
        mostrarCheckTaxa: false,
        usaCategoria: false,
        categoriaObrigatoria: false,
        textosDocumento: [],
        textosComplemento: [],
        anexosCr: [],
        form: {
          rateios: [],
          idTerceiro: 0, nomeTerceiro: '',
          tipoPessoa: 0,
          historico: '',
          idCategoriaFinanceira: 0, nomeCategoriaFinanceira: '',
          dataEmissao: new Date(),
          dataVencimento: null,
          dataBaixa: null,
          documento: '',
          complemento: '',
        },
      }
    },
    computed: {
      semCliente() { return this.form.tipoPessoa === 3; },
      sugestoesHistorico() { return sugestoesDoHistorico(this.origem && this.origem.historico, 110); },
      valor() { return this.origem ? this.origem.valor : (this.debito.valor || 0); },
      valorAbs() { return Math.abs(this.valor); },
      idsProjetoRateio() {
        return this.form.rateios.filter(r => r.idProjeto > 0).map(r => r.idProjeto);
      },
      chaveProjetos() { return this.idsProjetoRateio.join(','); },
      rateioValido() {
        const rateios = this.form.rateios;

        if (!rateios || rateios.length === 0) return false;
        if (rateios.some(r => !(r.idProjeto > 0) || !(r.idRubrica > 0) || !(r.idSubRubrica > 0))) return false;
        if (rateios.some(r => !((+r.valor || 0) > 0))) return false;

        const chaves = rateios.map(r => r.idProjeto + '-' + r.idRubrica + '-' + r.idSubRubrica);
        if (chaves.some((c, i) => chaves.indexOf(c) !== i)) return false;

        const soma = rateios.reduce((s, r) => s + (+r.valor || 0), 0);

        return Math.abs(Math.round((soma - this.valorAbs) * 100) / 100) < 0.005;
      },
      erros() {
        const e = {};
        if (this.baixarAgora === null) e.opcao = 'Escolha o que fazer com o débito';
        if (!this.form.tipoPessoa) e.tipoPessoa = 'Escolha o tipo';
        if (this.form.tipoPessoa > 0 && !this.semCliente && !this.form.idTerceiro) e.cliente = 'Campo obrigatório';
        if (this.semCliente && !this.form.historico.trim()) e.historico = 'Campo obrigatório';
        if (this.categoriaObrigatoria && !(this.form.idCategoriaFinanceira > 0)) e.categoria = 'Campo obrigatório';
        if (!this.rateioValido) e.rateio = 'Complete o rateio entre os projetos';
        if (this.baixarAgora === true && !this.form.dataBaixa) e.dataBaixa = 'Campo obrigatório';
        if (!this.form.dataVencimento) e.vencimento = 'Campo obrigatório';
        return e;
      },
    },
    watch: {
      baixarAgora() { this.carregarCheckTaxa(); },
      chaveProjetos() { this.carregarCheckTaxa(); },
    },
    mounted() {
      this.carregarDebito();
      this.carregarTextosPadrao();
      this.carregarConfigAnexos();
      this.carregarRegraCategoria();
    },
    methods: {
      erro(campo) { return this.validar ? this.erros[campo] : ''; },
      carregarDebito() {
        this.carregando = true;
        conciliacaoProjetoServico.debitoTransitoria(this.idContaCript, this.debito.idLancamento)
          .then(dados => {
            this.origem = dados;
            this.carregando = false;

            if (dados.idTerceiro > 0) {
              this.form.idTerceiro = dados.idTerceiro;
              this.form.nomeTerceiro = dados.nomeTerceiro;
            }

            this.form.dataEmissao = dados.dataStr ? moment(dados.dataStr, 'DD/MM/YYYY').toDate() : null;
            this.form.dataVencimento = this.form.dataEmissao;
          })
          .catch(() => {
            this.carregando = false;
            toastr.error('Não foi possível carregar o lançamento de débito.');
            this.$emit('fechar');
          });
      },
      carregarTextosPadrao() {
        conciliacaoProjetoServico.textosPadrao()
          .then(dados => {
            this.textosDocumento = (dados && dados.documentos) || [];
            this.textosComplemento = (dados && dados.complementos) || [];
          })
          .catch(() => {});
      },
      buscarPessoas(termo) { return conciliacaoProjetoServico.pessoasCredito(termo, this.form.tipoPessoa); },
      buscarCategorias(termo) { return conciliacaoProjetoServico.categoriasFinanceiras(termo); },
      aoEscolherCliente(opcao) {
        this.form.nomeTerceiro = opcao ? opcao.nome : '';
      },
      escolherTipoPessoa(tipo) {
        if (this.form.tipoPessoa === tipo) return;

        this.form.tipoPessoa = tipo;
        this.form.idTerceiro = 0;
        this.form.nomeTerceiro = '';

        if (tipo > 0) this.form.historico = '';
      },
      rateioParaEnvio() {
        return this.form.rateios.map(r => ({
          idProjeto: r.idProjeto,
          idRubrica: r.idRubrica,
          idSubRubrica: r.idSubRubrica,
          valor: +r.valor || 0,
        }));
      },
      carregarRegraCategoria() {
        conciliacaoProjetoServico.regraCategoria(this.idContaCript)
          .then(r => {
            this.usaCategoria = !!(r && r.utiliza);
            this.categoriaObrigatoria = this.usaCategoria && !!(r && r.obrigatoria);
          })
          .catch(() => { this.usaCategoria = true; this.categoriaObrigatoria = false; });
      },
      carregarCheckTaxa() {
        const ids = this.idsProjetoRateio;

        if (this.baixarAgora !== true || ids.length === 0) {
          this.mostrarCheckTaxa = false;
          this.comTaxa = false;
          return;
        }

        conciliacaoProjetoServico.checkTaxa(this.idContaCript, { idsProjeto: ids })
          .then(r => {
            this.mostrarCheckTaxa = !!(r && r.mostrar);
            this.comTaxa = !!(r && r.marcado);
          })
          .catch(() => { this.mostrarCheckTaxa = false; this.comTaxa = false; });
      },
      formatar(v) {
        return (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      dataStr(d) { return d ? moment(d).format('YYYY-MM-DD') : ''; },
      gravar() {
        if (this.gravando || this.carregando) return;

        this.validar = true;

        if (Object.keys(this.erros).length > 0) {
          toastr.error('Preencha os campos obrigatórios destacados.');
          return;
        }

        this.gravando = true;

        const payload = {
          idLancamentoDebito: this.debito.idLancamento,
          operacao: 'CR',
          criarContaReceber: true,
          baixarAgora: this.baixarAgora === true,
          dataBaixa: this.baixarAgora === true ? this.dataStr(this.form.dataBaixa) : '',
          contaReceber: {
            rateios: this.rateioParaEnvio(),
            idTerceiro: this.semCliente ? 0 : this.form.idTerceiro,
            historico: this.semCliente ? this.form.historico.trim() : '',
            idCategoriaFinanceira: this.form.idCategoriaFinanceira,
            dataEmissao: this.dataStr(this.form.dataEmissao),
            dataVencimento: this.dataStr(this.form.dataVencimento),
            documento: this.form.documento,
            complemento: this.form.complemento,
            valor: this.valorAbs,
            comTaxa: this.mostrarCheckTaxa && this.comTaxa,
          },
          criarTransferencia: false,
        };

        conciliacaoProjetoServico.regularizarTransitoria(this.idContaCript, payload)
          .then(resultado => {
            return this.enviarAnexos([
              { destino: DESTINO_CONTA_RECEBER, rotulo: 'contas a receber', ids: [resultado.idContaReceber], arquivos: this.anexosCr },
            ]).then(() => {
              this.gravando = false;
              (resultado.mensagens || []).forEach(m => toastr.success(m));
              this.$emit('concluido', resultado);
            });
          })
          .catch(resposta => {
            this.gravando = false;
            const mensagem = resposta && resposta.data ? resposta.data.message : '';
            toastr.error(mensagem || 'Não foi possível criar o contas a receber.');
          });
      },
    },
    template: `
      <div class="crt-back" @click.self="$emit('fechar')">
        <div class="crt-modal">
          <div class="crt-cab">
            <h4><i class="fa fa-plus-circle"></i> Criar conta a receber</h4>
            <small>O título nasce com o valor do débito e com a conta transitória como conta de baixa.</small>
          </div>

          <div class="crt-corpo">
            <div v-if="carregando" class="crt-carregando"><i class="fa fa-spinner fa-pulse"></i> Carregando o débito...</div>

            <template v-else>
              <div class="crt-resumo">
                <div class="crt-res-item">
                  <span>Débito na transitória</span>
                  <b class="mono">R$ {{ formatar(valorAbs) }}</b>
                </div>
                <div class="crt-res-item">
                  <span>Data</span>
                  <b class="mono">{{ origem.dataStr }}</b>
                </div>
                <div class="crt-res-item crt-res-lg">
                  <span>Histórico</span>
                  <b>{{ origem.historico || '—' }}</b>
                </div>
              </div>

              <div class="crt-opcoes" :class="{ 'crt-opcoes-erro': erro('opcao') }">
                <label class="crt-radio" :class="{ 'crt-radio-on': baixarAgora === true }">
                  <input type="radio" :value="true" v-model="baixarAgora">
                  <span><b>Baixar agora</b><small>o título já nasce conciliado com este débito</small></span>
                </label>
                <label class="crt-radio" :class="{ 'crt-radio-on': baixarAgora === false }">
                  <input type="radio" :value="false" v-model="baixarAgora">
                  <span><b>Deixar em aberto</b><small>o título fica a receber, para baixar depois</small></span>
                </label>
              </div>
              <span v-if="erro('opcao')" class="crt-msg">{{ erro('opcao') }}</span>

              <label v-if="mostrarCheckTaxa" class="crt-check">
                <input type="checkbox" v-model="comTaxa">
                <span>Taxa <small>marcado quando o projeto tem taxa cadastrada</small></span>
              </label>

              <div class="crt-aviso" v-if="baixarAgora === false">
                O débito de R$ {{ formatar(valorAbs) }} continua pendente na transitória. Quando o crédito
                entrar, selecione os dois lados e use <b>Baixar contas a receber</b>.
              </div>

              <bloco-operacao selo="CR" cor="cre" titulo="Contas a receber"
                              subtitulo="O título que nasce agora, com a transitória como conta de baixa"
                              :nota="baixarAgora === true ? 'Nasce baixado e conciliado com este débito.' : (baixarAgora === false ? 'Nasce em aberto, para baixar quando o crédito entrar.' : '')">
              <div class="crt-linha">
                <div class="crt-campo crt-campo-lg" :class="{ 'crt-invalido': erro('cliente') || erro('historico') || erro('tipoPessoa') }">
                  <label>Cliente <span class="crt-obr">*</span></label>
                  <div class="crt-seg">
                    <button type="button" :class="{ ativo: form.tipoPessoa === 1 }" @click="escolherTipoPessoa(1)">Pessoa física</button>
                    <button type="button" :class="{ ativo: form.tipoPessoa === 2 }" @click="escolherTipoPessoa(2)">Pessoa jurídica</button>
                    <button type="button" :class="{ ativo: form.tipoPessoa === 3 }" @click="escolherTipoPessoa(3)">Outros</button>
                  </div>
                  <selecao-busca v-if="form.tipoPessoa > 0 && !semCliente" v-model="form.idTerceiro" :texto="form.nomeTerceiro"
                                 :buscar="buscarPessoas" :placeholder="form.tipoPessoa === 1 ? 'Nome ou CPF...' : 'Nome ou CNPJ...'"
                                 @selecionado="aoEscolherCliente"></selecao-busca>
                  <complemento-sugerido v-if="semCliente" v-model="form.historico" :sugestoes="sugestoesHistorico" :maxlength="110"
                                        titulo-sugestoes="Histórico do débito na transitória"
                                        placeholder="Clique para ver o histórico do débito"></complemento-sugerido>
                  <span v-if="erro('tipoPessoa')" class="crt-msg">{{ erro('tipoPessoa') }}</span>
                  <span v-else-if="erro('cliente')" class="crt-msg">{{ erro('cliente') }}</span>
                  <span v-else-if="erro('historico')" class="crt-msg">{{ erro('historico') }}</span>
                  <small v-else-if="semCliente" class="crt-dica">O título nasce sem cliente, com este histórico.</small>
                </div>
                <div class="crt-campo crt-campo-lg">
                  <label>Conta de baixa</label>
                  <input type="text" class="form-control" :value="nomeContaTransitoria || 'Conta transitória'" disabled>
                </div>
              </div>

              <div class="crt-rateio">
                <rateio-projetos v-model="form.rateios" :id-conta-cript="idContaCript" :total="valorAbs"
                                 natureza="C" :projetos-livres="true" :validar="validar"
                                 titulo="Rateio entre projetos"></rateio-projetos>
              </div>

              <div class="crt-linha" v-if="baixarAgora === true">
                <div class="crt-campo crt-campo-sm" :class="{ 'crt-invalido': erro('dataBaixa') }">
                  <label>Data da baixa <span class="crt-obr">*</span></label>
                  <date-picker v-model="form.dataBaixa" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                  <span v-if="erro('dataBaixa')" class="crt-msg">{{ erro('dataBaixa') }}</span>
                  <small v-else class="crt-dica">Não precisa ser a data do débito.</small>
                </div>
              </div>

              <div class="crt-linha">
                <div v-if="usaCategoria" class="crt-campo crt-campo-lg" :class="{ 'crt-invalido': erro('categoria') }">
                  <label>Categoria financeira <span v-if="categoriaObrigatoria" class="crt-obr">*</span></label>
                  <selecao-busca v-model="form.idCategoriaFinanceira" :texto="form.nomeCategoriaFinanceira"
                                 :buscar="buscarCategorias" placeholder="Buscar categoria..."
                                 @selecionado="o => form.nomeCategoriaFinanceira = o ? o.nome : ''"></selecao-busca>
                  <span v-if="erro('categoria')" class="crt-msg">{{ erro('categoria') }}</span>
                </div>
                <div class="crt-campo crt-campo-lg">
                  <label>Complemento</label>
                  <complemento-sugerido v-model="form.complemento" :digitados="[form.documento]" titulo-digitados="Do documento" :cadastrados="textosComplemento" :maxlength="300"
                                        placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                </div>
              </div>

              <div class="crt-linha">
                <div class="crt-campo">
                  <label>Documento</label>
                  <complemento-sugerido v-model="form.documento" :digitados="[form.complemento]" titulo-digitados="Do complemento" :cadastrados="textosDocumento" :maxlength="30"
                                        placeholder="Clique para ver os textos cadastrados"></complemento-sugerido>
                </div>
                <div class="crt-campo crt-campo-sm">
                  <label>Emissão</label>
                  <date-picker v-model="form.dataEmissao" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" style="width:100%"></date-picker>
                </div>
                <div class="crt-campo crt-campo-sm" :class="{ 'crt-invalido': erro('vencimento') }">
                  <label>Vencimento <span class="crt-obr">*</span></label>
                  <date-picker v-model="form.dataVencimento" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                               :editable="false" :shortcuts="false" :clearable="false" :append-to-body="true"
                               :popup-style="{ zIndex: 3200 }" placeholder="Informe a data" style="width:100%"></date-picker>
                  <span v-if="erro('vencimento')" class="crt-msg">{{ erro('vencimento') }}</span>
                </div>
              </div>

              <div class="crt-linha">
                <div class="crt-campo crt-campo-lg" v-if="!semCliente">
                  <label>Histórico</label>
                  <input type="text" class="form-control" :value="form.nomeTerceiro" disabled>
                  <small class="crt-dica">Vem do cliente do título.</small>
                </div>
              </div>

              <anexos-operacao v-if="podeAnexarContaReceber" v-model="anexosCr" :limite="limiteAnexo"
                               titulo="Arquivos do contas a receber"
                               dica="Os arquivos vão para a pasta do contas a receber assim que o título for criado."></anexos-operacao>
              </bloco-operacao>
            </template>
          </div>

          <div class="crt-rodape">
            <button type="button" class="btn btn-default" @click="$emit('fechar')">Cancelar</button>
            <button type="button" class="btn btn-primary" :disabled="gravando || carregando" @click="gravar">
              <i class="fa" :class="gravando ? 'fa-spinner fa-pulse' : 'fa-check'"></i>
              {{ baixarAgora === false ? 'Criar em aberto' : 'Criar e conciliar' }}
            </button>
          </div>
        </div>
      </div>`,
  }
</script>

<style scoped>
  .crt-back { position: fixed; inset: 0; background: rgba(16,24,40,.45); z-index: 3100; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .crt-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.24); width: 100%; max-width: 900px; max-height: 92vh; display: flex; flex-direction: column; }
  .crt-cab { padding: 16px 20px 12px; border-bottom: 1px solid #e6eaee; }
  .crt-cab h4 { margin: 0 0 3px; font-size: 17px; font-weight: 600; color: #1c2024; }
  .crt-cab small { color: #8a939c; font-size: 12.5px; }
  .crt-corpo { padding: 16px 20px; overflow: auto; flex: 1; }
  .crt-carregando { padding: 30px; text-align: center; color: #8a939c; }
  .crt-resumo { display: flex; gap: 18px; flex-wrap: wrap; background: #f6f8fa; border: 1px solid #e6eaee; border-radius: 6px; padding: 10px 14px; margin-bottom: 16px; }
  .crt-res-item { display: flex; flex-direction: column; gap: 2px; min-width: 120px; }
  .crt-res-item span { font-size: 11px; text-transform: uppercase; letter-spacing: .3px; color: #8a939c; }
  .crt-res-item b { font-size: 14px; color: #1c2024; }
  .crt-res-lg { flex: 1; min-width: 240px; }
  .crt-res-lg b { font-weight: 500; font-size: 13px; }
  .mono { font-family: Consolas, Menlo, monospace; }
  .crt-sub-tit { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: #6b747e; margin: 10px 0 10px; }
  .crt-linha { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 12px; }
  .crt-rateio { margin-bottom: 12px; }
  .crt-campo { flex: 1; min-width: 160px; }
  .crt-campo-lg { flex: 2; min-width: 220px; }
  .crt-campo-sm { flex: 0 0 170px; min-width: 170px; }
  .crt-campo label { display: block; font-size: 12px; font-weight: 600; color: #4b545e; margin-bottom: 4px; }
  .crt-obr { color: #c0392b; }
  .crt-aviso { font-size: 12px; color: #8a5a00; background: #fdf3e0; border: 1px solid #f0d9a8; border-radius: 5px; padding: 7px 10px; margin-bottom: 14px; }
  .crt-seg { display: flex; border: 1px solid #c7cdd4; border-radius: 5px; overflow: hidden; height: 32px; margin-bottom: 6px; }
  .crt-seg button { flex: 1; border: none; background: #fff; color: #5b6570; font-size: 12.5px; padding: 0 8px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .crt-seg button:first-child { border-left: none; }
  .crt-seg button:hover { background: #f4f6f8; }
  .crt-seg button.ativo { background: #1ab394; color: #fff; font-weight: 600; }
  .crt-dica { display: block; margin-top: 3px; font-size: 11.5px; color: #8a939c; }
  .crt-check { display: flex; align-items: center; gap: 8px; margin: 10px 0 0; font-size: 12.5px; font-weight: 600; color: #5b6570; cursor: pointer; }
  .crt-check input { margin: 0; }
  .crt-check small { font-weight: 400; color: #8a94a0; margin-left: 4px; }

  .crt-msg { display: block; margin-top: 4px; font-size: 11.5px; color: #c0392b; }
  .crt-opcoes { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 4px; }
  .crt-opcoes-erro .crt-radio { border-color: #c0392b; background: #fdf6f5; }
  .crt-radio { flex: 1; min-width: 200px; display: flex; align-items: flex-start; gap: 8px; border: 1px solid #d3d8de; border-radius: 6px; padding: 9px 12px; margin: 0; cursor: pointer; font-weight: 400; }
  .crt-radio-on { border-color: #2b6cb0; background: #f3f8fd; }
  .crt-radio input { margin: 2px 0 0; }
  .crt-radio b { display: block; font-size: 13px; color: #1c2024; }
  .crt-radio small { color: #8a939c; font-size: 11.5px; }
  .crt-rodape { padding: 12px 20px; border-top: 1px solid #e6eaee; display: flex; justify-content: flex-end; gap: 8px; }
</style>

<style>
  .crt-invalido .form-control,
  .crt-invalido .mx-input { border-color: #c0392b; background: #fdf6f5; }
  .crt-invalido label { color: #c0392b; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ContaReceberTransitoriaModal.vue